<template>
    <div class="multi-logo">
        <transition name="trs-simple-fade" mode="out-in">
            <img class="multi-logo--image"
                    :src="src"
                    v-if="currentLogo"
                    :key="src">
        </transition>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import { mq } from '../../../util/dom/mq';

    export default {
        props: {
            effectName: {
                type: String,
                default: 'positive',
                validator: function(value) {
                    // The value must match one of these strings
                    return ['positive', 'negative'].includes(value);
                },
            },
            currentLogoName: {
                type: String,
                required: true,
            },
        },
        computed: {
            ...mapState('side-navigation', {
                isSideMenuOpen: 'isOpen',
            }),
            ...mapState('logos', ['currentLogo']),
            ...mapState('viewport', ['mq']),
            isLogoSmall() {
                return this.mq && mq('<=lg');
            },
            src() {
                // the logo style changes depending on the side menu visibility somehow ¯\_(ツ)_/¯
                const effectName = this.isSideMenuOpen ? 'positive' : this.effectName;

                return this.currentLogo[effectName][this.isLogoSmall ? 'small' : 'big'];
            },
        },
        methods: {
            ...mapActions('logos', ['setCurrentLogo']),
        },
        mounted() {
            this.setCurrentLogo({ name: this.currentLogoName });
        },
    };
</script>
